import './CurrentPasswordModal.scss';

import { CurrentPassword } from './form-items';
import { FormInstance } from 'antd/es/form';
import { SonarModal } from './modals';

import { Alert, Form } from 'antd';
import React, { useCallback, useRef } from 'react';

export interface CurrentPasswordModalProps {
	disabled?: boolean;
	error: boolean;
	errorMessage: string;
	failed: boolean;
	failedMessage: string;
	onCancel: () => void;
	onOk: (currentPassword: string) => void;
	open: boolean;
}

export const CurrentPasswordModal: React.FC<CurrentPasswordModalProps> = ({
	disabled,
	error,
	errorMessage,
	failed,
	failedMessage,
	onCancel,
	onOk,
	open
}) => {
	const formRef = useRef<FormInstance>(null);

	const handleOnOkClick = useCallback(() => {
		const { current } = formRef;

		if (current) {
			const currentPassword = current.getFieldValue('currentPassword');

			onOk(currentPassword);
			current.resetFields();
		}
	}, [ onOk ]);

	return (
		<SonarModal
			centered
			className='current-password-modal'
			onCancel={ onCancel }
			onOk={ handleOnOkClick }
			open={ open }
			title='Password Confirmation'>
			<Form ref={ formRef }>
				{ error && <Alert
					message={ errorMessage }
					type='error' /> }
				{ failed && <Alert
					message={ failedMessage }
					type='error' /> }
				<CurrentPassword
					disabled={ disabled }
					id='modal-password' />
			</Form>
		</SonarModal>
	);
};
